import styled from 'styled-components'

import type { SpectrumAlias } from '@cbhq/cds-common'

import { formatCustomColor } from '../../../componentsThemeMap'
import { Link } from '../../Link'
import type { RichTextPropsType, RenderNodePropsTypes } from '../types'

type HyperLinkProps = RichTextPropsType & {
  dataQa?: string
  target?: string
  styledLink?: string
}

export const InlineHyperLink = ({
  dataQa,
  target = '_self',
  foregroundInlineLink = 'blue60',
}: HyperLinkProps = {}): RenderNodePropsTypes => {
  return function hyperLink(node, children) {
    return children ? (
      <StyledInlineLink
        $color={foregroundInlineLink}
        data-qa={dataQa}
        target={target}
        href={node?.data?.target?.fields?.file?.url || node.data.uri || ''}
      >
        {children}
      </StyledInlineLink>
    ) : null
  }
}

type LinkAttrs = {
  style: React.CSSProperties & {
    '--link-color': string
  }
}

export const StyledInlineLink = styled(Link).attrs<{ $color: SpectrumAlias }>(
  (p): LinkAttrs => ({
    style: { '--link-color': formatCustomColor(p.$color) },
  }),
)`
  word-break: break-word;
  span {
    /* stylelint-disable-next-line declaration-no-important -- TODO Fix this */
    text-decoration: underline !important;
    color: var(--link-color);
  }
`
